import React, { useEffect, useState, useContext, useMemo } from "react";
import { Typography, Box, Backdrop, CircularProgress, TextField, MenuItem, Button, Stack} from "@mui/material";
import Header from "../Components/ui/Header";
import { API } from "../conf";
import { Context } from "../App";

export default function Rapport() {
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState(JSON.parse(sessionStorage.getItem('eglise')))
    const [agent, setAgent] = useState(JSON.parse(sessionStorage.getItem('user')))
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"]
    const [loading, setLoad] = useState(true)
    const [cloture_months, setCloture_months] = useState([])
    const [cloture_years, setCloture_years] = useState([])
    const [month, setMonth] = useState('')
    const [year, setYear] = useState('')
    const [pdf, setPdf] = useState()
    
    const eglise = useMemo(()=>organisation&&organisation.type==='église' ? organisation : eglises.find(el=>el._id===egliseId), [egliseId, eglises, organisation])

    function getRapport(cloture) {
        setPdf()
        if(eglise?._id){    
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise._id}/rapport/${cloture}`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function handleReeditRapport() {
        setPdf()
        if(eglise?._id){    
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise._id}/rapport/${month}/reedit`), {
                method:'GET',
                headers: {
                    Accept: 'application/pdf',
                    'Content-Type': 'application/pdf',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const blob = await response.blob()
                        setPdf(URL.createObjectURL(blob))
                    }
                    setLoad(false)
                }
            })
        }
    }

    function getMonths(year) {
        fetch(API.concat(`/eglises/${eglise.number}/cloture/years/${year}`), {
            method:'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    const months = json.sort((a, b) => new Date(a.date).getMonth()-new Date(b.date).getMonth())
                    setCloture_months(months)
                }
            }
        })
    }

    function reset() {
        setCloture_months([])
        setCloture_years([])
        setMonth('')
        setYear('')
        setPdf()
    }

    useEffect(()=>{
        if(eglise?.number) {
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise.number}/cloture/years`), {
                method:'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response=>{
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setCloture_years(json)
                    }setLoad(false)
                }
            })
        }
    }, [eglise])   
    
    useEffect(()=>{
        if (organisation&&organisation.type==='fédération') {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {_id:{$in: agent.eglises}}:{type:'église'})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json();
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    }, [organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])
    
    return(
        <div style={{display:'flex', flexDirection:'column', height:'100vh'}}>
            <Header/>
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Rapport mensuel</Typography>
            {organisation&&organisation.type==='fédération'&&<TextField select size="small" label="église" sx={{alignSelf:'end',marginBottom:3, width:'25%', marginRight:3, minWidth:'200px'}} value={egliseId} onChange={e=>setEgliseId(old=>{if(old!==e.target.value)reset(); return e.target.value})}>
                {eglises.map(eglise=><MenuItem key={eglise._id} value={eglise._id}>{`${eglise.nom} - ${eglise.commune.toUpperCase()}`}</MenuItem>)}
            </TextField>}
            {eglise&&<Box sx={{paddingX:'20px', marginTop:'30px', display:'flex', flexDirection:'column', flex:1}}>
                <Stack direction='row' spacing={5} sx={{marginBottom:'25px', alignItems:'center'}}>
                    <TextField
                    id="outlined-select-currency"
                    select
                    sx={{minWidth:'300px'}}
                    required
                    label="Année"
                    value={year}
                    onChange={(e)=> {
                        setYear(old=>{if(Number(e.target.value)!==old) setMonth(''); return Number(e.target.value)})
                        getMonths(Number(e.target.value))
                    }}
                    >
                    {cloture_years.map((year, index) => (<MenuItem key={index} value={year}><Typography>{year}</Typography></MenuItem>))}
                    </TextField>

                    {year !== '' && <TextField
                    id="outlined-select-currency"
                    select
                    sx={{minWidth:'300px'}}
                    required
                    label="Mois"
                    value={month}
                    onChange={(e)=> {
                        setMonth(e.target.value)
                        getRapport(e.target.value)
                    }}
                    >
                    {cloture_months.map((month, index) => (
                        <MenuItem key={index} value={month._id}>
                            <Typography sx={{}}>{months[new Date(month.date).getMonth()]}</Typography> 
                        </MenuItem>
                    ))}
                    </TextField>}

                    {pdf && <Button variant="contained" onClick={handleReeditRapport}>Rééditer</Button>}
                </Stack>
                
                {month !=='' && !loading && (pdf ? <embed src={pdf} width='100%' height='100%' type="application/pdf" style={{marginTop:20, minHeight:'800px'}} /> :
                <Typography textAlign='center'>Une erreur est survenue lors de la récupération du rapport, veuillez réessayer plus tard.<br/>Si le problème persiste veuillez contacter votre administrateur.</Typography>)}
            </Box>}

            <Backdrop open={loading}><CircularProgress color="inherit" /></Backdrop>
        </div>
    )
}